// extracted by mini-css-extract-plugin
module.exports = {"container":"_2aaba7f","background":"_6729e8b","title":"_200de83","subTitle":"_c825116","callout":"_c9974c8","games":"_b4d0d02","game":"_b3cfb78"};